
import './App.css';
import React, { Component } from "react";
import { AppBar } from '@mui/material';
import AppHeader from './AppHeader';
import {Box} from '@mui/material';
import Main, { Mainc } from './Main';
import { createBrowserRouter,RouterProvider } from 'react-router-dom';
import Payment from './admin_panel_crm/Payment';


import Footer from '../src/Footer'
import PropertyDescription, { PropertyDescriptionc } from '../src/PropertyDescription'
import Login from '../src/Login'
import Register from '../src/Register'
import Properties from '../src/Properties'

import Media from '../src/footer/Media'
import Career from '../src/footer/Career'
import Faqs from '../src/footer/Faqs'
import Community from '../src/footer/Community'
import Scholarship, { Schlorship } from '../src/footer/Schlorship'

import Contactus from '../src/footer/Contactus'
import Aboutus from '../src/footer/About'

///////////// admin panel /////////
import Dashboard from '../src/admin_panel_crm/Dashboard'
import Builder_profile, { Builder_profilec } from '../src/admin_panel_crm/Builder_profile'
import AddProperty, { AddPropertyc } from '../src/admin_panel_crm/AddProperty'
import Property_list, { Property_listc } from '../src/admin_panel_crm/Property_list'
import { Edit_Propertyc } from './admin_panel_crm/Edit_Property';



const router = createBrowserRouter([
    {
    path: "/",
    element: <Login />,
  },
  {
    path: "/main",
    element: <Mainc />,
  },
   {
    path: "/properties",
    element: <Properties />,
  },
     {
    path: "/Properties/:id",
    element: <PropertyDescriptionc />,
  },

      {
    path: "/register",
    element: <Register />,
  },
  
// Properties/description
 {
    path: "/about",
    element:<Aboutus/>,
  },
  {
    path: "/media",
    element:<Media/>,
  },
  {
    path: "/career",
    element:<Career/>,
  },
  {
    path: "/faq",
    element:<Faqs/>,
  },
 
  {
    path: "/scholarship",
    element:<Schlorship/>,
  },


 
  {
    path: "/contactus",
    element:<Contactus/>,
  },


//////////////// react etstate vendor panel ///////////

    {
    path: "/register",
    element: <Register />,
  },
    {
    path: "/admin/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/admin/builder",
    element: <Builder_profilec />,
  },
  {
    path: "/admin/addProperty",
    element: <AddPropertyc />,
  },
    {
    path: "/admin/propertyList",
    element: <Property_listc />,
  },
    {
    path: "/admin/editproperty/:id",
    element: <Edit_Propertyc />,
  },
 // Payment
        {
    path: "/admin/transaction",
    element: <Payment />,
  },


]);

{
  // <AppHeader/>
  //   <Footer/>
}


function App() {
  return (
    <div>   
      
      
      <Box sx={{backgroundColor:'#fafafc',mt:1}}>

        <React.StrictMode>
          <RouterProvider router={router} /> 
        
        </React.StrictMode>

  

      </Box>
     

    </div>
  );
}

export default App;
